import React from "react";
import DashboardLayout from "../examples/LayoutContainers/DashboardLayout";
import logo from "./bottoli_logo_transparent.png";
import DashboardNavbar from "../examples/Navbars/DashboardNavbar";

const WelcomePage = () => {
	const styles = {
		container: {
			minHeight: "100vh",
			//backgroundColor: "#f8f9fa",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center",
			padding: "2rem",
			fontFamily: "system-ui, -apple-system, sans-serif",
			marginTop: "-200px",
		},
		content: {
			maxWidth: "1000px",
			width: "100%",
			textAlign: "center",
			animation: "fadeIn 0.8s ease-out",
		},
		logoContainer: {
			marginBottom: "1rem",
		},
		logo: {
			maxWidth: "300px",
			height: "auto",
		},
		title: {
			fontSize: "2.5rem",
			color: "#2c3e50",
			fontWeight: "300",
			marginBottom: "1.5rem",
			"@media (max-width: 768px)": {
				fontSize: "2rem",
			},
		},
		subtitle: {
			fontSize: "1.25rem",
			color: "#666",
			maxWidth: "600px",
			margin: "0 auto 3rem auto",
			lineHeight: "1.6",
		},
		divider: {
			height: "4px",
			width: "60px",
			backgroundColor: "#003876",
			margin: "2rem auto",
			borderRadius: "2px",
		},
		poweredBy: {
			fontSize: "0.875rem",
			color: "#999",
			marginTop: "3rem",
		},
		poweredByText: {
			color: "#666",
			fontWeight: "500",
		},
		"@keyframes fadeIn": {
			from: {
				opacity: 0,
				transform: "translateY(20px)",
			},
			to: {
				opacity: 1,
				transform: "translateY(0)",
			},
		},
	};

	// Aggiungi gli stili delle animazioni al documento
	React.useEffect(() => {
		const styleSheet = document.createElement("style");
		styleSheet.textContent = `
      @keyframes fadeIn {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @media (max-width: 768px) {
        .title {
          font-size: 2rem;
        }
      }
    `;
		document.head.appendChild(styleSheet);

		return () => {
			document.head.removeChild(styleSheet);
		};
	}, []);

	return (
		<DashboardLayout>
			<DashboardNavbar></DashboardNavbar>
			<div style={styles.container}>
				<div style={styles.content}>
					<center>
						<div style={styles.logoContainer}>
							<img src={logo} alt="Bottoli Logo" style={styles.logo} />
						</div>
					</center>

					<h1 style={styles.title}>Benvenuto nel portale</h1>

					<p style={styles.subtitle}>Accedi a tutti gli strumenti e le informazioni di cui hai bisogno per gestire il tuo lavoro in modo efficiente</p>

					<div style={styles.divider} />

					<div style={styles.poweredBy}>
						Powered by <span style={styles.poweredByText}>EdilMate</span>
					</div>
				</div>
			</div>
		</DashboardLayout>
	);
};

export default WelcomePage;
